export let isAndroid = navigator.userAgent.includes('Android')

export let isIPhone = navigator.userAgent.includes('iPhone')
